module.exports = __webpack_public_path__ + "static/media/user_input_1.3377e448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindRose/user_input_1.png
// module id = 2499
// module chunks = 0